import React from "react";
import GenericModal from "components/MainApp/atoms/Modals/GenericModal";

import styles from "./DeleteBusinessNodeModal.module.scss";
import i18n from "i18n";
const DeleteBusinessNodeModal = ({ open, handleClose, handleCancel, handleConfirm, businessNodeName }) => {
    const content = <div className={styles["delete-business-node-modal-content"]}>
        <div className={styles["delete-business-node-modal-title"]}>{i18n.t("deleting.information")}</div>
        <div className={styles["delete-business-node-modal-buttons"]}>
            <div onClick={handleCancel}>{i18n.t("stay")}</div>
            <div onClick={handleConfirm}>{i18n.t("delete.confirm").toUpperCase()}</div>
        </div>
    </div>
    return (
        <div className={styles["delete-business-node-modal-container"]}>
            <GenericModal title={i18n.t("branch.deleting.question", { businessNodeName: businessNodeName })}
                open={open}
                content={content}
                handleClose={handleClose}></GenericModal>
        </div>
    );
}


export default DeleteBusinessNodeModal;